import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SectorsService } from 'projects/services/src/app/API/sectors.service';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
	@Input() label: string;
	@Input() placeholder: string;
	states: any;
	searchtext: string;
	constructor(private geographiesService: GeographiesService) {

		if (this.placeholder) {
			this.placeholder = this.placeholder;
		} else {
			this.placeholder = 'Search by keyword';
		}
	}
	@Output() searchValue: EventEmitter<string> = new EventEmitter<string>();
	// @Output() sectorName: EventEmitter<string> = new EventEmitter<string>();
	// @Output() subSectorName: EventEmitter<string> = new EventEmitter<string>();
	// @Output() tainingCentreType: EventEmitter<string> = new EventEmitter<string>();
	ngOnInit() {
		// this.geographiesService.getStates().subscribe(states => {
		// 	this.states = states[0].states;
		// });
	}

	search(searchtext) {
		this.searchValue.emit(searchtext);
	}
}
